import React from 'react';
import { Link } from 'react-router-dom';

interface PaginationProps {
  next: () => void;
  previous: () => void;
}

export function Pagination({ next, previous }: PaginationProps): JSX.Element {
  return (
    <div className="g">
      <ul className="pagination justify-content-center justify-content-md-start">
        <li className="page-item">
          <Link className="page-link" to="#" onClick={previous}>
            <em className="icon ni ni-chevrons-left" />
            Anterior
          </Link>
        </li>

        <li className="page-item">
          <Link className="page-link" to="#" onClick={next}>
            Próximo
            <em className="icon ni ni-chevrons-right" />
          </Link>
        </li>
      </ul>
    </div>
  );
}
